import { useEffect } from 'react';
import { withRouter } from 'react-router';

const ScrollToTop = ({ location: { pathname } }) => {
  useEffect(() => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

export default withRouter(ScrollToTop);
